import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en.json';

i18next.addResourceBundle('en', 'direction', en);

const UpdateDirectionConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Update Direction',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.DIRECTION,
  permission: PERMISSION.UPDATE,
  routes: [
    {
      path: '/direction/:id',
      component: React.lazy(() => import('./UpdateDirection')),
    },
  ],
};

export default UpdateDirectionConfig;
